// import LiangHao from "@/components/page/LiangHao";
import Product from "@/components/page/Product";
import Broadband from "@/components/page/Broadband";
import QueryOrder from "@/components/page/QueryOrder";
import AboutUs from "@/components/page/AboutUs";
import Customize from "@/components/page/Customize";
export default {
  name: 'MainIndex',
  components: {
    Product: Product,
    Broadband: Broadband,
    QueryOrder: QueryOrder,
    AboutUs: AboutUs,
    Customize: Customize
  },
  data: function data() {
    return {
      tabIndex: 2,
      fullPath: ''
    };
  },
  setup: function setup() {},
  mounted: function mounted() {
    var tabIndex = this.$route.query.tabIndex; // console.log(tabIndex);

    if (tabIndex) {
      this.tabIndex = tabIndex;
    }

    var customerName = this.$route.params.source;

    if (customerName) {
      window.$customerName = customerName;
    }

    this.fullPath = window.location.href;
  }
};